import React from "react";
import styles from "./TranscriptTableHeader.module.css";
import {useAppDispatch, useAppSelector} from "../../../../../app/hooks";
import {TranscriptTableSortingField} from "../../../../../api/generated";
import {SortableHeaderCell, TableSort} from "../../../../elements/sortableHeaderCell/SortableHeaderCell";
import {transcriptTableRequestSelector, updateTranscriptTableRequest} from "../../transcriptListSlice";

export const TranscriptTableHeader: React.FC = () => {
    const dispatch = useAppDispatch()
    const {sortBy, sortDirection} = useAppSelector(transcriptTableRequestSelector)
    const sort: TableSort<TranscriptTableSortingField> = {sortBy, sortDirection}

    const handleSort = (nextSort: TableSort<TranscriptTableSortingField>) => {
        dispatch(updateTranscriptTableRequest(nextSort))
    }

    return <div className={styles.wrapper}>
        <SortableHeaderCell className={styles.chunnelCell} title={"Channel"} sortKey={TranscriptTableSortingField.Channel} sort={sort} onSort={handleSort}/>
        <SortableHeaderCell className={styles.customerCell} title={"Customer"} sortKey={TranscriptTableSortingField.Customer} sort={sort} onSort={handleSort}/>
        <SortableHeaderCell className={styles.dateTimeCell} title={"Date & Time"} sortKey={TranscriptTableSortingField.DateTime} sort={sort} onSort={handleSort}/>
        <span className={styles.contactInformationCell}>Contact Information</span>
        <span className={styles.chatOutcomeCell}>Chat Outcome</span>
        <span className={styles.followUpCell}>Follow Up</span>
    </div>
}
